module.exports = __webpack_public_path__ + "img/Invite_btn.9e8995ca.png";